import { memo } from 'react';
import { getUnitStatus, isBackendUnit, getUnitProperty } from '../schemas/unitSchema';
import { getFlowError } from '../constants/flowErrors';
import { STATUS_MAP } from '../constants/statusConstants';

export const StatusTags = memo(({ selectedUnitItem, unitIssues: unitIssuesGrouped }) => {
  const statuses = [];
  const addedTypes = new Set();

  // Flatten the per-unit grouped issues passed directly from the row
  const unitIssues = unitIssuesGrouped
    ? Object.values(unitIssuesGrouped).flat()
    : [];

  const unitStatus = getUnitStatus(selectedUnitItem, unitIssues);
  
  // Special handling for backend unit - only show disconnected tag if applicable
  if (isBackendUnit(selectedUnitItem)) {
    if (unitStatus === 'disconnected') {
      statuses.push({ value: "disconnected", label: "Disconnected", color: "#dc3545" });
    }
  } else {
    // Helper function to add status without duplicates
    const addStatus = (type) => {
      if (!addedTypes.has(type) && STATUS_MAP[type]) {
        addedTypes.add(type);
        statuses.push({ 
          value: type, 
          ...STATUS_MAP[type] 
        });
      }
    };

    // Add tags from flow error issues first
    unitIssues.forEach(issue => {
      const issueId = issue?.Issue?.ID;
      const flowError = getFlowError(issueId);
      
      if (flowError) {
        addStatus(flowError.type);
      }
    });
    
    // Check for unit property statuses
    if (selectedUnitItem.unit_status === 'disabled') {
      addStatus('disabled');
    }
    
    if (selectedUnitItem.isUnitDisconnected && selectedUnitItem.unit_status !== 'disabled') {
      addStatus('disconnected');
    }
    
    if (selectedUnitItem.clogged) {
      addStatus('clogged');
    }
    
    if (selectedUnitItem.isUnitStuck) {
      addStatus('stuck');
    }
    
    if (selectedUnitItem.daily_unit_use === 0 || selectedUnitItem.daily_unit_use === '') {
      addStatus('unused');
    }

    if (getUnitProperty(selectedUnitItem, 'statusInfo._wizard_is_done') === false) {
      addStatus('wizard');
    }

    if (getUnitProperty(selectedUnitItem, 'statusInfo._out_of_order_active', false)) {
      addStatus('out_of_order');
    }

    if (getUnitProperty(selectedUnitItem, 'statusInfo._water_flush_button_active', false)) {
      addStatus('manual_flush');
    }
  }
  
  return (
    <div className="status-tags" style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '4px',
      alignItems: 'center'
    }}>
      {statuses.map((status, index) => (
        <span
          key={`${status.value}-${index}`}
          className="badge"
          style={{
            backgroundColor: status.color,
            display: 'inline-block',
            padding: '0.25em 0.6em',
            fontSize: '0.875em',
            fontWeight: '500',
            lineHeight: '1',
            color: '#fff',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            borderRadius: '0.25rem',
            marginBottom: '2px'
          }}
        >
          {status.label}
        </span>
      ))}
    </div>
  );
});